import getSelectedTableView from './getSelectedTableView';
import { owaComputedFn } from 'owa-computed-fn';

const getComputedIsInCheckedMode: () => boolean = owaComputedFn(
    function getComputedIsInCheckedMode(): boolean {
        return !!getSelectedTableView()?.isInCheckedMode;
    }
);
export default getComputedIsInCheckedMode;
